// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"53e5c872","843":"013933ed","910":"ded96dad"}[chunkId] + ".chunk.css";
};